import { RootState } from '~/store/store';
import { State } from './models';

export const getPurchaseInfo = (store: RootState): State['purchaseInfo'] | undefined => store?.purchase?.purchaseInfo;

export const getWorkflowState = (store: RootState): State['workflowState'] | undefined =>
  store?.purchase?.workflowState;
